"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _underscore = require("underscore");

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _DynoEditor = _interopRequireDefault(require("./DynoEditor"));

var _DynoEditor2 = require("lead-flows-ui/actions/DynoEditor");

var _ContactProperties = require("lead-flows-ui/actions/ContactProperties");

var _Settings = require("lead-flows-ui/actions/Settings");

var _Users = require("lead-flows-ui/actions/Users");

var _RouteGenerators = require("lead-flows-ui/lib/RouteGenerators");

var _DynoEditor3 = require("lead-flows-ui/constants/DynoEditor");

var _Settings2 = require("lead-flows-ui/selectors/Settings");

var _ContactProperties2 = require("lead-flows-ui/selectors/ContactProperties");

var _RequestState = require("lead-flows-ui/utils/RequestState");

var _Scopes = require("lead-flows-ui/selectors/Scopes");

var _Users2 = require("lead-flows-ui/selectors/Users");

var _Scopes2 = require("lead-flows-ui/constants/Scopes");

var _Dynos = require("lead-flows-ui/selectors/Dynos");

var EDITOR_STEPS = Object.values(_DynoEditor3.STEPS || {});

var LeadFlowEditor = _react.default.createClass({
  displayName: "LeadFlowEditor",
  propTypes: {
    brandingEnabled: _react.default.PropTypes.bool.isRequired,
    contactPropertiesRequestState: _react.default.PropTypes.instanceOf(_RequestState.RequestState).isRequired,
    dispatch: _react.default.PropTypes.func,
    dynosEditor: _react.default.PropTypes.object.isRequired,
    dynoId: _react.default.PropTypes.string.isRequired,
    gates: _react.default.PropTypes.object.isRequired,
    isCrmUser: _react.default.PropTypes.bool.isRequired,
    isFetching: _react.default.PropTypes.bool.isRequired,
    isForm: _react.default.PropTypes.bool.isRequired,
    route: _react.default.PropTypes.object.isRequired,
    settings: _react.default.PropTypes.object.isRequired,
    step: _react.default.PropTypes.oneOf(EDITOR_STEPS),
    subscriptions: _react.default.PropTypes.object.isRequired,
    users: _react.default.PropTypes.array.isRequired,
    usersRequestState: _react.default.PropTypes.instanceOf(_RequestState.RequestState).isRequired,
    redirectUrl: _react.default.PropTypes.string,
    hasForm: _react.default.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      step: (0, _underscore.first)(EDITOR_STEPS)
    };
  },
  componentWillMount: function componentWillMount() {
    var _this$props = this.props,
        dispatch = _this$props.dispatch,
        dynoId = _this$props.dynoId;
    dispatch((0, _DynoEditor2.fetchDynoForEditorIfNeeded)(dynoId));
    dispatch((0, _Settings.fetchSettingsIfNeeded)());
    dispatch((0, _ContactProperties.fetchContactPropertiesIfNeeded)());
    dispatch((0, _ContactProperties.fetchContactPropertiesIfNeeded)());
    dispatch((0, _Users.fetchUsersIfNeeded)());
  },
  componentDidUpdate: function componentDidUpdate() {
    var _this$props2 = this.props,
        dispatch = _this$props2.dispatch,
        dynosEditor = _this$props2.dynosEditor,
        dynoId = _this$props2.dynoId;

    if (!dynosEditor.hasLoaded && !dynosEditor.isLoading) {
      dispatch((0, _DynoEditor2.fetchDynoForEditorIfNeeded)(dynoId));
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.props.dispatch((0, _DynoEditor2.clearEditableDyno)());
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor." + suffix;
  },
  handleAdvanceStep: function handleAdvanceStep() {
    var _this$props3 = this.props,
        currentStep = _this$props3.step,
        dynoId = _this$props3.dynoId,
        gates = _this$props3.gates,
        dispatch = _this$props3.dispatch,
        redirectUrl = _this$props3.redirectUrl,
        hasForm = _this$props3.hasForm;
    var steps = EDITOR_STEPS;

    if (!gates['LeadFlows:AudienceTargeting']) {
      steps = steps.filter(function (step) {
        return step !== _DynoEditor3.STEPS['TARGETING'];
      }); // removing the targeting step for those gated
    }

    if (!hasForm) {
      steps = steps.filter(function (step) {
        return step !== _DynoEditor3.STEPS.FORM && step !== _DynoEditor3.STEPS.THANKS && step !== _DynoEditor3.STEPS.KICKBACK;
      });
    }

    var stepIndex = steps.indexOf(currentStep);
    dispatch((0, _reactRouterRedux.push)((0, _RouteGenerators.getDynoEditorRoute)(dynoId, steps[stepIndex + 1], redirectUrl)));
  },
  handleChangeStep: function handleChangeStep(step) {
    var _this$props4 = this.props,
        dynoId = _this$props4.dynoId,
        dispatch = _this$props4.dispatch,
        redirectUrl = _this$props4.redirectUrl;
    dispatch((0, _reactRouterRedux.push)((0, _RouteGenerators.getDynoEditorRoute)(dynoId, step, redirectUrl)));
  },
  renderLoadingComponent: function renderLoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 400
    });
  },
  renderFetchingErrorComponent: function renderFetchingErrorComponent(status) {
    if (status === 404) {
      return _react.default.createElement(_UIErrorMessage.default, {
        illustration: "errors/map",
        illustrationProps: {
          width: 220
        },
        title: _I18n.default.text(this.langKey('flowDoesntExist'))
      }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: this.langKey('flowDoesntExistDescription'),
        options: {
          dashboardLink: (0, _RouteGenerators.getDynoListRoute)()
        }
      })));
    }

    return _react.default.createElement(_UIErrorMessage.default, null, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('unableToLoadFlowsData')
    })));
  },
  render: function render() {
    var _this$props5 = this.props,
        brandingEnabled = _this$props5.brandingEnabled,
        contactPropertiesRequestState = _this$props5.contactPropertiesRequestState,
        dispatch = _this$props5.dispatch,
        dynoId = _this$props5.dynoId,
        dynosEditor = _this$props5.dynosEditor,
        gates = _this$props5.gates,
        isCrmUser = _this$props5.isCrmUser,
        isFetching = _this$props5.isFetching,
        isForm = _this$props5.isForm,
        route = _this$props5.route,
        settings = _this$props5.settings,
        step = _this$props5.step,
        subscriptions = _this$props5.subscriptions,
        users = _this$props5.users,
        redirectUrl = _this$props5.redirectUrl;
    var isLoading = !dynosEditor.hasLoaded || isForm && contactPropertiesRequestState.shouldShowLoader();

    if (isLoading) {
      return this.renderLoadingComponent();
    } else if (dynosEditor.fetchingHasError) {
      return this.renderFetchingErrorComponent(dynosEditor.fetchingRecentError.status);
    }

    return _react.default.createElement(_DynoEditor.default, {
      brandingEnabled: brandingEnabled,
      dispatch: dispatch,
      dyno: dynosEditor.editableDyno,
      dynoId: dynoId,
      gates: gates,
      handleAdvanceStep: this.handleAdvanceStep,
      handleChangeStep: this.handleChangeStep,
      hasChanges: dynosEditor.hasChanges,
      isCrmUser: isCrmUser,
      isEditing: true,
      isSettingsFetching: isFetching,
      lastSaveAt: dynosEditor.lastSaveAt,
      route: route,
      saving: dynosEditor.saving,
      savingHasError: dynosEditor.savingHasError,
      savingRecentError: dynosEditor.savingRecentError,
      settings: settings,
      step: step,
      subscriptions: subscriptions,
      validation: dynosEditor.validation,
      users: users,
      redirectUrl: redirectUrl
    });
  }
});

function mapStateToProps(state, ownParams) {
  var redirectUrl = ownParams.location.query.redirectUrl;
  var dynosEditor = state.dynosEditor,
      gates = state.gates,
      subscriptions = state.subscriptions;
  return {
    brandingEnabled: !(0, _Scopes.hasScope)(state, _Scopes2.LEADIN_NO_BRANDING),
    contactPropertiesRequestState: (0, _ContactProperties2.getRequestState)(state),
    dynosEditor: dynosEditor,
    gates: gates,
    isCrmUser: (0, _Scopes.hasScope)(state, _Scopes2.HUB_CRM_PRODUCT),
    isFetching: (0, _Settings2.isSettingsFetching)(state),
    isForm: ownParams.params.step === 'form',
    settings: (0, _Settings2.getSettings)(state),
    subscriptions: subscriptions,
    users: (0, _Users2.fetchUsers)(state),
    usersRequestState: (0, _Users2.getUsersRequestState)(state),
    redirectUrl: redirectUrl ? decodeURIComponent(redirectUrl) : redirectUrl,
    hasForm: (0, _Dynos.getHasForm)(state)
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps)(LeadFlowEditor);

exports.default = _default;
module.exports = exports.default;